import React from 'react';

export const TipIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.1541 1.21525C14.0088 -0.4649 16.8555 -0.394667 18.6251 1.37494C20.3947 3.14455 20.4649 5.99119 18.7847 7.84593L15.2121 11.7898C14.2288 12.8752 13.7218 14.3096 13.8045 15.7719L13.9256 17.9103C13.966 18.6252 13.6169 19.3063 13.0127 19.6907C12.2306 20.1885 11.2078 20.0762 10.5522 19.4206L6.97398 15.8424L6.59438 16.1862C5.81657 16.8908 4.62284 16.8614 3.88074 16.1193C3.13864 15.3772 3.1092 14.1834 3.81377 13.4056L4.15763 13.026L0.579363 9.44775C-0.0761659 8.79222 -0.18845 7.76937 0.309271 6.98728C0.693717 6.3831 1.37475 6.03395 2.08972 6.07441L4.22814 6.19546C5.69038 6.2782 7.12477 5.7712 8.21021 4.78793L12.1541 1.21525ZM11.1884 4.89119C10.9825 4.68526 10.6578 4.65841 10.4208 4.82767L7.98671 6.56634C7.91814 6.61533 7.83992 6.64921 7.75727 6.66573L4.76156 7.26488C4.29499 7.35821 4.12068 7.93388 4.45715 8.27035L11.7294 15.5426C12.0659 15.8791 12.6416 15.7048 12.7349 15.2382L13.334 12.2425C13.3506 12.1599 13.3845 12.0817 13.4334 12.0131L15.1721 9.57895C15.3414 9.34196 15.3145 9.01733 15.1086 8.81138L11.1884 4.89119Z"
                fill="#D2AE6D"
            />
        </svg>
    );
};

export const PrintIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <g clip-path="url(#clip0_4947_4410)">
                <path
                    d="M5 7.49935V1.66602H15V7.49935"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M5.0013 15H3.33464C2.89261 15 2.46868 14.8244 2.15612 14.5118C1.84356 14.1993 1.66797 13.7754 1.66797 13.3333V9.16667C1.66797 8.72464 1.84356 8.30072 2.15612 7.98816C2.46868 7.6756 2.89261 7.5 3.33464 7.5H16.668C17.11 7.5 17.5339 7.6756 17.8465 7.98816C18.159 8.30072 18.3346 8.72464 18.3346 9.16667V13.3333C18.3346 13.7754 18.159 14.1993 17.8465 14.5118C17.5339 14.8244 17.11 15 16.668 15H15.0013"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M15 11.666H5V18.3327H15V11.666Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4947_4410">
                    <rect
                        width="20"
                        height="20"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
